import { ST, BUILD_VERSION } from './Chrome';

///////////////////////////////////////////////////////////////////////////////
// Country hero images — shared by the catalog pages (App.jsx) and the eSIM
// country landings (EsimLanding.jsx). Details: docs/CARRIER_LOGOS.md.
///////////////////////////////////////////////////////////////////////////////

export const DEFAULT_HERO = `${ST}/images/2/bg-temple.jpg`;

// The hero's teal wash sits over a country photo when we have one. When we
// don't, it stands on its own rather than borrowing an unrelated landmark.
const HERO_TINT = 'linear-gradient(rgba(48,164,174,.82), rgba(30,147,157,.92))';
export function heroStyle(url) {
  return {
    backgroundImage: url
      ? `${HERO_TINT}, url(${url})`
      : 'linear-gradient(rgba(48,164,174,.97), rgba(30,147,157,1))',
  };
}

// Curated hero art for the pinned destinations (null = plain teal gradient).
export const PINNED_HEROES = {
  TH: DEFAULT_HERO,
  PH: `${ST}/images/countries/philippines.jpg`,
  JP: null,
  VN: `${ST}/images/countries/vietnam.jpg`,
  MY: `${ST}/images/countries/malaysia.jpg`,
  SG: `${ST}/images/countries/singapore.jpg`,
};

// Try the legacy country hero images; fall back to the plain gradient.
// Hero art is looked up by ISO code first — the curated set is named that way
// (us.jpg, uk.jpg) — then by country name, which is how the bulk of the library
// is named (mexico.jpg, costa_rica.jpg). GB is filed under "uk".
const HERO_ISO_ALIAS = { gb: ['gb', 'uk'] };

export function resolveHero(name, cb, code) {
  const slug = String(name || '').toLowerCase();
  // Country heroes live under the unversioned /st/b bucket, which Cloudflare
  // caches for a year as immutable. A newly added image requested during a
  // deploy can get a 404 cached against it and stay broken for a year — which
  // is what happened to the first US hero. Stamping the build gives each
  // release a fresh key.
  const v = BUILD_VERSION && BUILD_VERSION !== 'dev' ? `?v=${encodeURIComponent(BUILD_VERSION)}` : '';
  const iso = String(code || '').toLowerCase();
  const isoNames = HERO_ISO_ALIAS[iso] || (iso ? [iso] : []);
  const candidates = [
    ...isoNames.map((i) => `${ST}/images/countries/${i}.jpg${v}`),
    `${ST}/images/countries/${slug.replace(/\s+/g, '-')}.jpg${v}`,
    // 15 of the country photos use underscores (costa_rica.jpg and friends)
    `${ST}/images/countries/${slug.replace(/\s+/g, '_')}.jpg${v}`,
    `${ST}/images/countries/${slug.replace(/\s+/g, '')}.jpg${v}`,
  ];
  let i = 0;
  const tryNext = () => {
    // No photo for this country: fall through to the plain teal gradient
    // rather than another country's landmark.
    if (i >= candidates.length) return cb(null);
    const url = candidates[i++];
    const img = new Image();
    img.onload = () => cb(url);
    img.onerror = tryNext;
    img.src = url;
  };
  tryNext();
}
